// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1361":"1427874e00975ed3","2888":"96245be14fd22bcb","6366":"bf3b217b7955ee0e","7918":"1427874e00975ed3"}[chunkId] + ".css";
};